<template>
  <div class="case-edit-dailog col-block block">
    <div class="form-container col-block width-full">
      <caseBase
        :ref="'form-main'"
        :mode="'edit'"
        :isUpdate="true"
        :layoutBlocks="[
          'form'
        ]"
        :dataset="caseData.dataset"
        :defaultData="defaultData"
        @onError="error => onError = error"
        @unloadAlert="alert => unloadAlert = alert"
      ></caseBase>
    </div>
    <div :style="{ height: '15px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Cancel'/* ___ */ }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit && validateSendCase()">
        <span>{{ 'Update'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  putCase
} from '../../api'
import caseBase from '../../components/case/base.vue'
import toastMethods from '../../mixins/toastMethods.vue'

export default {
  components: {
    caseBase
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      caseData: {},
      onError: false,
      onSubmit: false
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    defaultData () {
      return {
        'case': this.caseData,
        'analysis': {}
      }
    }
  },
  created () {
    this.caseData = {
      ...this.param.caseData
    }
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setModal2Action'
    ]),
    async validateSendCase () {
      this.onSubmit = true
      try {
        const forms = Object.entries(this.$refs).filter(([key]) => key.startsWith('form-')).map(([key, ref]) => ref[0] || ref)
        let success = true
        for (let form of forms) {
          let result = await form.validateSubmit()
          if (form && !result) {
            success = false
          }
        }
        if (success) {
          let datas = []
          for (let form of forms) {
            let data = await form.submit()
            if (form && !data) {
              throw new Error()
            } else {
              datas.push(data)
            }
          }
          await this.sendCase(datas[0])
        }
      } catch (error) {
      }
    },
    async sendCase (formData) {
      let config = this.$ls.get('userInfo')
      let id = this.param.caseData.id
      let data = {
        ...formData.data
      }
      if (['supervisor'].includes(this.user.role)) {
        data.new_user_id = formData.data.user_id
      }
      const sendCase = async () => {
        try {
          let response = await putCase(id, data, config)
          let newCase = response.data.data
          this.addToast('success', response.data.result.message)
          this.$emit('changeModal', {}, newCase)
        } catch (error) {
          this.addToast('error', !error.response ? error.message : error.response.data.result.message)
        }
        this.onSubmit = false
      }
      let owner = formData.users.find(user => user.id === this.caseData.user.id)
      let newOwner = formData.users.find(user => user.id === formData.data.user_id)
      if ((owner && newOwner) && owner.id !== newOwner.id) {
        this.setModal2Action({
          action: 'toast',
          width: '496px',
          customStyles: {
            padding: 0,
            border: 0
          },
          param: {
            type: 'alert',
            content: '<span style="color:#FA3D3D">Once you change the owner, the case will be transferred from ' + [owner.first_name, owner.last_name].filter(x => x).join(' ') + ' to ' + [newOwner.first_name, newOwner.last_name].filter(x => x).join(' ') + '. Do you want to transfer it? </span>'/* ___ */,
            buttons: [
              {
                title: 'Cancel'/* ___ */,
                type: 'gray',
                result: false
              },
              {
                title: 'Change'/* ___ */,
                type: 'alert',
                result: true
              }
            ]
          },
          callback: async result => {
            if (result) {
              await sendCase()
            } else {
              this.onSubmit = false
            }
          }
        })
      } else {
        await sendCase()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseEdit.vue